import React from 'react';
import facebook from "../../assets/images/articles/facebook.svg";
import web from "../../assets/images/articles/web.svg";
import ellipsis from "../../assets/images/articles/Ellipse.svg";
import pinterest from "../../assets/images/articles/pinterest.svg";
import social from "../../assets/images/articles/social.svg";

const NewShareIcons = ({ author,shareImage,shareTitle, shareLink, shareUrl}) => {
  // let shareUrl=author.title
  const shareOnFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?url=${encodeURIComponent(shareUrl)}`;
    window.open(facebookUrl, '_blank');
  };

  const shareOnPinterest = () => {
    const pinterestUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(shareImage)}&description=${encodeURIComponent(shareTitle)}`;
    window.open(pinterestUrl, '_blank');
  };

  const shareOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`;
    window.open(twitterUrl, '_blank');
  };

  return (
    <div className="blog-icon">
      <a href="#" onClick={shareOnFacebook}>
        <img src={facebook} alt="Facebook" />
      </a>
        <a href="#" onClick={shareOnPinterest}>
          <img src={pinterest} alt="Pinterest" />
        </a>
        <a href="#" onClick={shareOnTwitter}>
        <img src={social} alt="Twitter" />
      </a>
      <a href="#" onClick={shareOnTwitter}>
        <img src={web} alt="Web" />
      </a>
    </div>
  );
};

export default NewShareIcons;